import React from 'react';
import { HeroBanner } from '../components/home/HeroBanner';
import { FeaturesSection } from '../components/home/FeaturesSection';
import { CategorySection } from '../components/home/CategorySection';
import { FeaturedProducts } from '../components/home/FeaturedProducts';
import { DealsSection } from '../components/home/DealsSection';
import { PromoBanners } from '../components/home/PromoBanners';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { NewsletterSection } from '../components/home/NewsletterSection';
import { BrandsSection } from '../components/home/BrandsSection';
import { featuredProducts, bestSellers, newArrivals, dealsOfTheDay } from '../data/products';
export function HomePage() {
  return <div className="min-h-screen" data-id="element-1307">
      {/* Hero & Category Sidebar Section */}
      <div className="bg-white pt-4 pb-8" data-id="element-1308">
        <div className="max-w-7xl mx-auto px-4" data-id="element-1309">
          <div className="flex flex-col lg:flex-row gap-6" data-id="element-1310">
            {/* Desktop Sidebar */}
            <CategorySection data-id="element-1311" />

            {/* Hero Banner */}
            <div className="flex-1 overflow-hidden rounded-xl" data-id="element-1312">
              <HeroBanner data-id="element-1313" />
            </div>
          </div>
        </div>
      </div>

      <FeaturesSection data-id="element-1314" />

      <FeaturedProducts title="Featured Products" subtitle="Handpicked gadgets just for you" products={featuredProducts} viewAllLink="/products?featured=true" data-id="element-1315" />

      <DealsSection products={dealsOfTheDay} data-id="element-1316" />

      <PromoBanners data-id="element-1317" />

      <FeaturedProducts title="Best Sellers" subtitle="Most loved by our customers" products={bestSellers} viewAllLink="/products?bestseller=true" data-id="element-1318" />

      <div className="bg-gray-50" data-id="element-1319">
        <FeaturedProducts title="New Arrivals" subtitle="Fresh additions to our collection" products={newArrivals} viewAllLink="/products?new=true" data-id="element-1320" />
      </div>

      <TestimonialsSection data-id="element-1321" />
      <BrandsSection data-id="element-1322" />
      <NewsletterSection data-id="element-1323" />
    </div>;
}